
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import QuoteModal from './QuoteModal';
import LanguageSwitcher from './LanguageSwitcher';

export default function Header() {
  const { t } = useTranslation('common');
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isQuoteModalOpen, setIsQuoteModalOpen] = useState(false);

  const navLinks = [
    { name: t('nav.home'), path: '/' },
    { name: t('nav.about'), path: '/about' },
    { name: t('nav.services'), path: '/services' },
    { name: t('nav.products'), path: '/products' },
    { name: t('nav.contact'), path: '/contact' },
  ];

  return (
    <>
      <header className="bg-white shadow-sm sticky top-0 z-40">
        <div className="container mx-auto px-3 md:px-6">
          <div className="flex items-center justify-between h-12 md:h-16">
            {/* Logo */}
            <Link to="/" className="flex items-center gap-1.5 md:gap-3">
              <img 
                src="https://static.readdy.ai/image/87705512d5c7f2a4b5504cc452accb9e/d573f1d2b846674670fcfa9ce25fd113.jpeg" 
                alt="GB Group Logo" 
                className="h-8 md:h-12 w-auto object-contain"
              />
              <span className="text-base md:text-xl font-bold text-gray-900 whitespace-nowrap">GB Group</span>
            </Link>

            {/* Desktop Navigation */}
            <nav className="hidden lg:flex items-center gap-4 md:gap-8">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  className="text-xs md:text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors whitespace-nowrap"
                >
                  {link.name}
                </Link>
              ))}
            </nav>

            {/* Right Section */}
            <div className="flex items-center gap-2 md:gap-4">
              <LanguageSwitcher />
              <button
                onClick={() => setIsQuoteModalOpen(true)}
                className="hidden md:flex items-center gap-1.5 md:gap-2 bg-teal-600 text-white px-3 md:px-6 py-1.5 md:py-2.5 rounded-lg hover:bg-teal-700 transition-colors text-xs md:text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="ri-file-text-line text-sm md:text-base"></i>
                {t('header.getQuote')}
              </button>

              {/* Mobile Menu Button */}
              <button
                onClick={() => setIsMenuOpen(!isMenuOpen)}
                className="lg:hidden p-1.5 md:p-2 text-gray-700 hover:text-teal-600 cursor-pointer"
                aria-label="Toggle menu"
              >
                <i className={`${isMenuOpen ? 'ri-close-line' : 'ri-menu-line'} text-lg md:text-2xl`}></i>
              </button>
            </div>
          </div>

          {/* Mobile Navigation */}
          {isMenuOpen && (
            <nav className="lg:hidden py-3 md:py-4 border-t border-gray-100">
              {navLinks.map((link) => (
                <Link
                  key={link.path}
                  to={link.path}
                  onClick={() => setIsMenuOpen(false)}
                  className="block py-1.5 md:py-2 text-xs md:text-sm font-medium text-gray-700 hover:text-teal-600 transition-colors"
                >
                  {link.name}
                </Link>
              ))}
              <button
                onClick={() => {
                  setIsQuoteModalOpen(true);
                  setIsMenuOpen(false);
                }}
                className="mt-2 md:mt-3 w-full flex items-center justify-center gap-1.5 md:gap-2 bg-teal-600 text-white px-3 md:px-4 py-1.5 md:py-2 rounded-lg hover:bg-teal-700 transition-colors text-xs md:text-sm font-medium whitespace-nowrap cursor-pointer"
              >
                <i className="ri-file-text-line text-sm md:text-base"></i>
                {t('header.getQuote')}
              </button>
            </nav>
          )}
        </div>
      </header>

      <QuoteModal isOpen={isQuoteModalOpen} onClose={() => setIsQuoteModalOpen(false)} />
    </>
  );
}
